var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 30 30"}},[_c('circle',{attrs:{"cx":"15","cy":"15","r":"14.5","fill":"currentColor","fill-opacity":".1","stroke":"currentColor"}})])
}
var staticRenderFns = []

export default { render: render }